import React, { useState } from "react";
import Header from "./Header";
import Box from "@mui/material/Box";
import {List } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import colors from "../../../utils/constant/colors";
import { useLocation, useNavigate } from "react-router-dom";
import routerPath from "../../../utils/router/routerPath";
import HomeIcon from "@mui/icons-material/Home";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import GroupAdd from "@mui/icons-material/GroupAdd";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import { useDispatch, useSelector } from "react-redux";
import * as sessionActions from "../../../store/session";
import { toast } from "react-toastify";
import { signOut } from "../../../utils/sessionBridge";
import ComputerIcon from "@mui/icons-material/Computer";
// PermMedia is the closest stock MUI icon to "media library"; it's used as
// the navigation entry for the new /media tab.
import PermMediaIcon from "@mui/icons-material/PermMedia";
// Help / documentation page entry (S3 setup, Media tab usage, FAQ).
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";


const Layout = ({ children, buttonName, showSideBar, active, showAdmin ,isLeave}) => {
  const [activeItem, setActiveItem] = useState(0);
  const dispatch = useDispatch();
  const sessionUser = useSelector((state) => state.session.user);
  const navigate = useNavigate();
  const location = useLocation();
  const handleItemClick = (path) => {
    setActiveItem(path);
    navigate(path);
  };
  const userRoleFromLocalStorage = localStorage.getItem("user");
  const convertData = JSON.parse(userRoleFromLocalStorage);
  const sidebarItems =
    convertData?.user_role === "admin_user"
      ? [
          {
            path: routerPath.home,
            icon: (val) => (
              <HomeIcon
                sx={{
                  color:
                    active == 0
                      ? colors.white
                      : location.pathname === val
                      ? colors.white
                      : "",
                }}
              />
            ),
          },
          {
            path: routerPath.events,
            icon: (val) => (
              <ComputerIcon
                sx={{
                  color: location.pathname === val ? colors.white : "",
                }}
              />
            ),
          },
          // Media library (server <-> S3) – admin-only.
          {
            path: routerPath.media,
            icon: (val) => (
              <PermMediaIcon
                sx={{
                  color: location.pathname === val ? colors.white : "",
                }}
              />
            ),
          },
          {
            path: routerPath.normaluser,
            icon: (val) => (
              <PeopleAltIcon
                sx={{
                  color: location.pathname === val ? colors.white : "",
                }}
              />
            ),
          },

          {
            path: routerPath.webinarGhostUser,
            icon: (val) => (
              <GroupAdd
                sx={{
                  color: location.pathname === val ? colors.white : "",
                }}
              />
            ),
          },
          {
            path: routerPath.setting,
            icon: (val) => (
              <SettingsIcon
                sx={{
                  color: location.pathname === val ? colors.white : "",
                }}
              />
            ),
          },
          // Knowledge-base / docs (S3 setup guide etc.).
          {
            path: routerPath.help,
            icon: (val) => (
              <HelpOutlineIcon
                sx={{
                  color: location.pathname === val ? colors.white : "",
                }}
              />
            ),
          },
        ]
      : [

          {
            path: routerPath.home,
            icon: (val) => (
              <HomeIcon
                sx={{
                  color:
                    active == 0
                      ? colors.white
                      : location.pathname === val
                      ? colors.white
                      : "",
                }}
              />
            ),
          },
          {
            path: routerPath.events,
            icon: (val) => (
              <ComputerIcon
                sx={{
                  color: location.pathname === val ? colors.white : "",
                }}
              />
            ),
          },
        ];
  const sideNavStyle = {
    minWidth: 0,
    justifyContent: "center",
    padding: "10px",
  };

  const logout = async () => {
    const refresh = sessionUser && sessionUser.refresh;
    dispatch(sessionActions.logout());
    await signOut(refresh);
    window.location.assign(routerPath.login);
  };
  return (
    <>
      <Header buttonName={buttonName} />
      {showSideBar ? (
        <Box sx={{ display: showSideBar ? "flex" : "contents" }}>
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              borderRight: 1,
              borderColor: colors.inactive,
            }}
          > 
            <List>
              <ListItem disablePadding sx={{ display: "block" }}>
                {sidebarItems.map((item, index) => (
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      px: 2.5,
                    }}
                    onClick={() => handleItemClick(item.path)}
                    key={index}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        justifyContent: "center",
                        padding: "10px",
                        borderRadius: "10px",
                        backgroundColor:
                          active == 0 && index == 0
                            ? colors.primary
                            : location.pathname === item.path
                            ? colors.primary
                            : "",
                      }}
                    >
                      {item.icon(item.path)}
                    </ListItemIcon>
                  </ListItemButton>
                ))}

                <ListItemButton
                  sx={{
                    minHeight: 48,

                    px: 2.5,
                  }}
                  onClick={logout}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      borderRadius: "10px",
                      justifyContent: "center",
                      padding: "10px",
                    }}
                  >
                    <LogoutIcon />
                  </ListItemIcon>
                </ListItemButton>
              </ListItem>
            </List>
          </Box>
          <Box>{children}</Box>
        </Box>
      ) : (
        <Box>{children}</Box>
      )}
    </>
  );
};

export default Layout;
